const normalize = (value) => (value || '').trim().toLowerCase();

const isBeneficiaireAyantDroit = (beneficiaire, ayantDroit) =>
  normalize(beneficiaire) === normalize(ayantDroit);

const getAccountDestination = (beneficiaire, isOwnAccount) =>
  isOwnAccount ? 'votre compte' : `le compte de ${beneficiaire}`;

const getRepaymentMessage = (reglement, ayantDroit) => {
  const { dateMiseEnBanque, beneficiaire } = reglement || {};
  const isOwnAccount = isBeneficiaireAyantDroit(beneficiaire, ayantDroit);
  const accountDestination = getAccountDestination(beneficiaire, isOwnAccount);

  if (dateMiseEnBanque) {
    return `Remboursement effectué le ${dateMiseEnBanque} sur ${accountDestination}.`;
  }

  return `Votre dossier est en cours de traitement par nos équipes de gestion.`;
};

export default getRepaymentMessage;
